export const SIZES_AND_CRUSTS_TARGETS = {
  SIZES_AND_CRUSTS: 'data'
};
